import { Component, computed, input, OnDestroy, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { NgScrollbar } from 'ngx-scrollbar';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { commitmentsSelectors } from '../../../../store/commitments/commitments.selectors';
import { AppState } from '../../../../store/app-state';
import { fillIn } from '../../../../../assets/styles/animations';

import { TemporaryContractorIconComponent } from '../../../temporary-contractor-icon/temporary-contractor-icon.component';
import { COMMITMENTS_TYPE } from '../../../constants/interaction-bar.constants';
import {
  COMPANY_DROPDOWN_SELECT_TYPES,
  CompanyDropdownData,
  ICompanyDropdownSelectEvent,
} from '@app/types/company-dropdown.types';

@Component({
  selector: 'app-company-dropdown',
  templateUrl: './company-dropdown.component.html',
  styleUrls: ['./company-dropdown.component.scss'],
  animations: [fillIn],
  imports: [TemporaryContractorIconComponent, NgScrollbar, CommonModule],
})
export class CompanyDropdownComponent implements OnDestroy {
  optionSelected = output<ICompanyDropdownSelectEvent>();
  hideAddCompany = input<boolean>(false);
  commitmentType = input<COMMITMENTS_TYPE>();

  allContractors = toSignal(this.store.select(commitmentsSelectors.selectAllContractors));

  filteredContractors = computed(() => {
    const contractors = this.allContractors();
    const commitmentType = this.commitmentType();

    if (commitmentType !== COMMITMENTS_TYPE.INVOICES) {
      return contractors;
    }

    return {
      invitedContractors: contractors.invitedContractors.filter(
        (contractor) => contractor.has_approved_contracts,
      ),
      temporaryContractors: contractors.temporaryContractors.filter(
        (contractor) => contractor.has_approved_contracts,
      ),
    };
  });

  isDestroyed$ = new Subject();

  constructor(private store: Store<AppState>) {}

  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }

  selectOption(contractor: CompanyDropdownData, isTemporaryContractor: boolean) {
    this.optionSelected.emit({
      type: COMPANY_DROPDOWN_SELECT_TYPES.SELECT,
      data: contractor,
      isTemporaryContractor,
    });
  }

  switchDropdown() {
    this.optionSelected.emit({ type: COMPANY_DROPDOWN_SELECT_TYPES.CHANGE_DROPDOWN });
  }
}
